
$(document).ready(function() {

    var $body = $('body'),
        $mobileMenuCategories = $('.mobile-menu__category');

    // Toggle mobile menu
    $(document).on('click', '.header-mobile__toggle--menu', function(e) {
        e.preventDefault();

        $body.removeClass('search-open');
        $body.toggleClass('mobile-menu-open');
    });

    // Toggle mobile menu category
    $(document).on('click', '.mobile-menu__category-toggle', function(e) {
        e.preventDefault();

        var $targetParent = $(this).parent();

        // Close all currently open categories
        $mobileMenuCategories.not($targetParent).removeClass('mobile-menu__category--open');

        // Open the target category
        $targetParent.toggleClass('mobile-menu__category--open');
    });
});